import { useAppSelector } from '@/app/store/hooks';
import { selectMinesStatus } from '@/entities/mines';

import { MinesBetForm } from './MinesBetForm';
import { MinesPlayingPanel } from './MinesPlayingPanel';
import { MinesResultPanel } from './MinesResultPanel';

export function MinesBetPanel() {
  const status = useAppSelector(selectMinesStatus);

  return (
    <>
      {status === 'idle' && <MinesBetForm />}
      {status === 'playing' && <MinesPlayingPanel />}
      {(status === 'busted' || status === 'won') && <MinesResultPanel />}
    </>
  );
}
